import { makeStyles } from "tss-react/mui";

import { styled, Theme } from "@mui/material";
import Badge, { BadgeProps } from "@mui/material/Badge";

export const CustomBadge = styled(Badge)(({ theme }) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    verticalAlign: "middle",
    lineHeight: 0,
    "& .MuiBadge-badge": {
        height: "16px",
        minWidth: "16px",
        padding: theme.spacing(0, 1),
        fontSize: "11px",
        color: theme.palette.emteria.text.inverse,
        backgroundColor: theme.palette.emteria.badge,
    },
}));

const useStyles = makeStyles()((theme: Theme) => ({
    filterBadge: {
        cursor: "pointer",
        marginLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        alignSelf: "center",
        transform: "translateY(-1px)",
        "& .fa-filter": {
            fontSize: 16,
            lineHeight: 1,
            color: theme.palette.emteria.indicator,
        },
    },
}));

export const FilterBadge = (props: BadgeProps) => {
    const { classes } = useStyles();

    return (
        <CustomBadge className={classes.filterBadge} overlap="rectangular" {...props}>
            <i className="fa-solid fa-filter" />
        </CustomBadge>
    );
};
